<ng-container *transloco="let t">
<tui-accordion class="tui-space_top-5 tui-space_bottom-5">
    <button tuiAccordion>{{ t('parentLearn.accordion.description') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3" [innerHTML]="t('parentLearn.accordion.descriptionContent.paragraph1')"></p>
        <img src="../../../../../assets/img/scheme1.jpg" class="img-text-100" alt="">
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.descriptionContent.paragraph2') }}</p>
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.descriptionContent.paragraph3') }}</p>
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.descriptionContent.paragraph4') }}</p>
    </tui-expand>
    <button tuiAccordion>{{ t('parentLearn.accordion.verbalSigns') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.verbalSignsContent.intro') }}</p>
        
        <h4 class="tui-space_top-3 tui-space_bottom-3">
            {{ t('parentLearn.accordion.verbalSignsContent.examplesTitle') }}
        </h4>
        <ul class="tui-list tui-list_large tui-space_bottom-3">
            @for (item of t('parentLearn.accordion.verbalSignsContent.examples'); track item) {
            <li class="tui-list__item">{{ item }}</li>
            }
        </ul>
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.verbalSignsContent.explanation') }}</p>
        
        <h4 class="tui-space_top-3 tui-space_bottom-3">
            {{ t('parentLearn.accordion.verbalSignsContent.title') }}
        </h4>
        <ul class="tui-list tui-list_large">
            @for (item of t('parentLearn.accordion.verbalSignsContent.phrases'); track item) {
            <li class="tui-list__item">{{ item }}</li>
            }
        </ul>
    </tui-expand>
    <button tuiAccordion>{{ t('parentLearn.accordion.physicalSigns') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.physicalSignsContent.paragraph1') }}</p>
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.physicalSignsContent.paragraph2') }}</p>
    </tui-expand>
    <button tuiAccordion>{{ t('parentLearn.accordion.behavior') }}</button>
    <tui-expand>
        <ul class="tui-list tui-list_large">
            @for (item of t('parentLearn.accordion.behaviorContent'); track item) {
            <li class="tui-list__item">{{ item }}</li>
            }
        </ul>
    </tui-expand>
    <button tuiAccordion>{{ t('parentLearn.accordion.externalManifestations') }}</button>
    <tui-expand>
        <ul class="tui-list tui-list_large">
            @for (item of t('parentLearn.accordion.externalManifestationsContent'); track item) {
            <li class="tui-list__item">{{ item }}</li>
            }
        </ul>
    </tui-expand>
    <button tuiAccordion>{{ t('parentLearn.accordion.functions') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.functionsContent') }}</p>
    </tui-expand>
    <button tuiAccordion>{{ t('parentLearn.accordion.examples') }}</button>
    <tui-expand>
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.examplesContent.example1') }}</p>
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.examplesContent.explanation1') }}</p>
        
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.examplesContent.example2') }}</p>
        <p class="text tui-space_bottom-3">{{ t('parentLearn.accordion.examplesContent.explanation2') }}</p>
    </tui-expand>
</tui-accordion>
</ng-container>